<template>
  <div class="tw:flex tw:flex-col tw:w-full tw:flex-1">
    <template v-if="!loading && combos.length === 0">
      <div class="tw:flex tw:flex-col tw:items-center tw:justify-center tw:gap-4 tw:py-16 tw:w-full tw:mx-auto tw:my-auto">
        <IconGoogle name="inventory_2" size="3rem" color="var(--fontcolor)" />
        <TextPlay :text="$t('combos.empty_state.title')" size="xl" weight="semibold" color="var(--fontcolor)" />
        <TextPlay :text="$t('combos.empty_state.description')" size="sm" color="var(--text-color)" class="tw:text-center tw:max-w-sm" />
        <ButtonPlayV2 :text="$t('combos.empty_state.create_button')" variant="filled" @click="emit('create')" />
      </div>
    </template>

    <template v-else>
      <TablePlay
        :columns="columns"
        :data="tableData"
        :loading="loading"
        :empty-text="$t('combos.empty_state.title')"
        hoverable
        clickable-rows
        @row-click="(row) => emit('edit', row.id)"
      >
        <template #title="{ row }">
          <TextPlay :text="row.title" size="sm" weight="semibold" color="var(--fontcolor)" class="tw:cursor-pointer" @click="emit('edit', row.id)" />
        </template>
        <template #created_at="{ row }">
          <TextPlay :text="formatDateTime(row.created_at)" size="sm" color="var(--text-color)" />
        </template>
        <template #updated_at="{ row }">
          <TextPlay :text="formatDateTime(row.updated_at)" size="sm" color="var(--text-color)" />
        </template>
        <template #actions="{ row }">
          <div class="tw:flex tw:items-center tw:justify-end tw:gap-2">
            <ButtonPlayV2 :text="$t('combos.texts.edit')" variant="ghost" size="sm" icon="edit" @click="emit('edit', row.id)" />
            <ButtonPlayV2 :text="$t('combos.texts.delete')" variant="ghost" size="sm" color="var(--feedback-error-500)" icon="delete" @click="emit('delete', row.id)" />
          </div>
        </template>
      </TablePlay>
    </template>
  </div>
</template>

<script lang="ts" setup>
import { computed } from "vue";
import { useI18n } from "vue-i18n";
import { play, ID } from "@voomp/play-back";
import { useDateFormat } from "@/composables/useDateFormat";
import { TablePlay } from "@/components/atomic";

const { t } = useI18n();
const { formatDateTime } = useDateFormat();

const props = defineProps<{
  combos: Awaited<ReturnType<typeof play.combo.list>>;
  loading: boolean;
}>();

const emit = defineEmits<{
  (e: 'edit', comboId: ID): void;
  (e: 'delete', comboId: ID): void;
  (e: 'create'): void;
}>();

const columns = computed(() => [
  { key: 'title', label: t('combos.field_title'), sortable: true },
  { key: 'created_at', label: t('combos.creation_date'), sortable: true },
  { key: 'updated_at', label: t('combos.update_date'), sortable: true },
  { key: 'actions', label: '', width: '200px' },
]);

const tableData = computed(() => props.combos as Record<string, unknown>[]);
</script>
